export default "<pa-checkbox\n    [selected]=\"control.value\"\n    (isSelectedChange)=\"setValue($event)\">{{ schema.title }}</pa-checkbox>\n"